import noop from '../utils/noop'
import shallowEqual from 'fbjs/lib/shallowEqual'
import $ from 'jquery'
import forEach from 'lodash/forEach'
import includes from 'lodash/includes'
import { findDOMNode } from 'react-dom'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'

const FILE_UPLOAD_OPTIONS = ['dataType', 'type', 'url']
const FILE_UPLOAD_CALLBACKS = [
  'always',
  'onAdd',
  'onDone',
  'onFail',
  'onSubmit'
]

export default class FileInput extends PureComponent {
  static propTypes = {
    accept: PropTypes.string,
    always: PropTypes.func,
    dataType: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    onAdd: PropTypes.func,
    onChange: PropTypes.func,
    onDone: PropTypes.func,
    onFail: PropTypes.func,
    onSubmit: PropTypes.func,
    type: PropTypes.oneOf(['POST', 'PUT', 'PATCH']),
    url: PropTypes.string.isRequired
  }

  static defaultProps = {
    type: 'POST',
    dataType: 'json',
    onAdd: noop,
    onChange: noop,
    onDone: noop,
    onFail: noop,
    onSubmit: noop,
    always: noop
  }

  componentDidMount() {
    const $el = $(findDOMNode(this))
    $el.fileupload({
      url: this.props.url,
      type: this.props.type,
      dataType: this.props.dataType,
      replaceFileInput: false
    })

    $el
      .on('fileuploadadd', this.props.onAdd)
      .on('fileuploadchange', this.props.onChange)
      .on('fileuploaddone', this.props.onDone)
      .on('fileuploadfail', this.props.onFail)
      .on('fileuploadsubmit', this.props.onSubmit)
      .on('fileuploadalways', this.props.always)
  }

  componentWillReceiveProps(nextProps) {
    if (shallowEqual(this.props, nextProps)) {
      return
    }

    const $el = $(findDOMNode(this))

    forEach(nextProps, (value, key) => {
      if (this.isFileUploadOption(key)) {
        $el.fileupload('option', key, value)
      } else if (this.isFileUploadCallback(key)) {
        $el.off(key, this.props[key])
        $el.on(key, value)
      }
    })
  }

  componentWillUnmount() {
    $(findDOMNode(this)).fileupload('destroy')
  }

  isFileUploadOption(prop) {
    return includes(FILE_UPLOAD_OPTIONS, prop)
  }

  isFileUploadCallback(prop) {
    return includes(FILE_UPLOAD_CALLBACKS, prop)
  }

  render() {
    const { accept, name, disabled } = this.props

    return <input type="file" accept={accept} name={name} disabled={disabled} />
  }
}



// WEBPACK FOOTER //
// ../src/components/FileInput.js